export default "__VITE_ASSET__BPnYfSS5__"